import { Release, ReleaseAssetItem, ReleaseAssetTypes } from '../models/release';
import { OverlayService } from '../../shared/services/overlayService';
import { NotificationService } from '../../shared/services/notification.service';
import { ReleaseTreeService } from '../services/release-tree-service';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { SubsectionService } from '../../shared/services/subsection.service';
import { PermissionService } from '../../shared/services/permissions.service';

export function deleteRelease(params: {
  projectId: string;
  release: Release;
  sectionId: string;
  subsectionId: string;
  overlayService: OverlayService;
  notificationService: NotificationService;
  releaseTreeService: ReleaseTreeService;
  subsectionService: SubsectionService;
  translatePipe: TranslatePipe;
}) {
  const {
    projectId,
    release,
    releaseTreeService,
    overlayService,
    translatePipe,
    notificationService,
    sectionId,
    subsectionId,
    subsectionService,
  } = params;

  notificationService
    .open({
      title: translatePipe.transform('confirmation'),
      description: translatePipe.transform('delete_aboutToDelete'),
      description3: `"${release.title}"`,
      description2: translatePipe.transform('delete_warningText'),
      confirmBtn: translatePipe.transform('yes'),
      cancelBtn: translatePipe.transform('no'),
      cssClass: 'common-delete-modal',
      isCloseButtonHidden: true,
    })
    .subscribe({
      next: (confirm: boolean) => {
        if (!confirm) {
          return;
        }

        releaseTreeService.deleteRelease(projectId, release.id!).subscribe({
          next: () => {
            releaseTreeService.deleteReleaseNodeById(release.id!);
            subsectionService.navigateSubsection({
              projectId: projectId,
              sectionId: sectionId,
              subsectionId: subsectionId,
              navigationType: 'release',
            });
          },
          error: () => {
            overlayService.showError(translatePipe.transform('deleteFailed'));
          },
        });
      },
    });
}

export function prepareReleaseAsset(asset: ReleaseAssetItem) {
  switch (asset.assetType) {
    case ReleaseAssetTypes.File:
      asset.signedURL = asset.previewImages?.[0];
      asset.contentType = asset.contentTypes?.[0];
      break;
  }
}

export function canEditRelease(permissionService: PermissionService): boolean {
  return permissionService.canUpdateProject();
}
